import { createContext, useContext } from "react";

import type { TableActionsMenuContextValue } from "./types-table-actions-menu";

export const TableActionsMenuContext = createContext<TableActionsMenuContextValue | null>(null);

export function useTableActionsMenuContext(): TableActionsMenuContextValue {
  const context = useContext(TableActionsMenuContext);
  if (!context)
    throw new Error("TableActionsMenu.* deve ser usado dentro de TableActionsMenu.Root");
  return context;
}
